import { ButtonBase, CircularProgress } from '@mui/material';
import { ChevronDown } from 'lucide-react';
import { SelectMenu, SelectMenuOption } from 'src/components/SelectMenu';
import { CustomAttributeValue } from 'src/graphql/entities/custom-attributes/custom-attributes.types';
import { CustomAttributeEditProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { YesNoPill } from './yes-no-pill';

const YES = 'true';
const NO = 'false';

const OPTIONS: SelectMenuOption[] = [
  { value: YES, title: 'Yes', label: <YesNoPill value /> },
  { value: NO, title: 'No', label: <YesNoPill value={false} /> },
];

export const CheckboxEditor = ({
  value,
  definition: { label },
  onChange,
  onSave,
  disabled,
  saving,
}: CustomAttributeEditProps) => {
  const checked = getKindLikeValueSafely(value, 'checkbox') === true;

  const handleChange = (next: string) => {
    const nextChecked = next === YES;
    if (nextChecked === checked) {
      return;
    }

    const updated: CustomAttributeValue = { kind: 'checkbox', value: nextChecked };
    onChange(updated);
    onSave(updated);
  };

  return (
    <SelectMenu
      label={label}
      options={OPTIONS}
      value={checked ? YES : NO}
      onChange={handleChange}
      disabled={disabled}
      menuWidth="8rem"
      renderTrigger={({ getTriggerProps }) => (
        <ButtonBase
          {...getTriggerProps()}
          focusRipple
          sx={{ borderRadius: '999px', '&.Mui-disabled': { opacity: 0.6 } }}
        >
          <YesNoPill
            value={checked}
            sx={{ cursor: disabled ? 'default' : 'pointer', pr: '0.25rem' }}
            trailing={
              saving ? (
                <CircularProgress size="0.875rem" sx={{ mx: '0.375rem' }} />
              ) : (
                <ChevronDown size="1rem" style={{ marginLeft: '0.125rem' }} />
              )
            }
          />
        </ButtonBase>
      )}
    />
  );
};
